/* RESPONSIBLE TEAM: team-automation-foundations */
import Route from '@ember/routing/route';
import type Transition from '@ember/routing/transition';
import { inject as service } from '@ember/service';
import { ReactRoute } from 'embercom/lib/react-route';
import type RouterService from '@ember/routing/router-service';
import type AppService from 'embercom/services/app-service';

// For non-standalone apps: redirects to apps.app.automation.fin-ai-agent.ask
// (kept for backward compatibility with bookmarks and external links).
// For standalone apps: renders directly as a ReactRoute, avoiding the automation
// route's permission guards and messenger settings loading.
export class AskIndexRoute extends Route {
  @service declare router: RouterService;
  @service declare appService: AppService;

  beforeModel(transition: Transition) {
    if (this.appService.app.canUseStandalone) {
      return;
    }
    this.router.replaceWith('apps.app.automation.fin-ai-agent.ask', {
      queryParams: transition.to?.queryParams ?? {},
    });
  }

  reactEnabled() {
    return this.appService.app.canUseStandalone;
  }
}

export default ReactRoute(AskIndexRoute);
